import { render, staticRenderFns } from "./CompareCalendars.vue?vue&type=template&id=70d6603e&scoped=true&"
import script from "./CompareCalendars.vue?vue&type=script&lang=js&"
export * from "./CompareCalendars.vue?vue&type=script&lang=js&"
import style0 from "./CompareCalendars.vue?vue&type=style&index=0&id=70d6603e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d6603e",
  null
  
)

export default component.exports